import styled from '@emotion/styled';
import { MergedTheme } from '../../../theme';

export const IconContainer = styled.div<{ theme?: MergedTheme; isActive?: boolean }>`
  margin-left: ${({ theme }) => theme.spacing(3)};
  margin-top: ${({ theme }) => theme.spacing(0.75)};
  cursor: pointer;
`;
